// @ts-nocheck
import {
  ECONDA_SESSION_ID_COOKIE,
  ECONDA_VISITOR_ID_COOKIE,
} from 'shared/consts'
import { getCookieByName } from 'shared/utils/getCookie'
import Storage from 'views/assets/scripts/services/storage/storage'

export type OptimizelyVisitorData = {
  status: 'new' | 'returning'
}

export class OptimizelyVisitor {
  static STORAGE_KEY = 'optimizely-visitor'
  static STATUSES: Array<OptimizelyVisitorData['status']> = ['new', 'returning']

  constructor(private storage: Storage) {}

  isReturningVisitor(): boolean {
    const { cookie = '' } = document

    const econdaSessionId = getCookieByName(
      ECONDA_SESSION_ID_COOKIE,
      cookie
    )?.split(':')[0]

    const econdaVisitorId = getCookieByName(
      ECONDA_VISITOR_ID_COOKIE,
      cookie
    )?.split(':')[0]

    const isNotFalsy = Boolean(econdaSessionId && econdaVisitorId)

    return isNotFalsy && econdaSessionId !== econdaVisitorId
  }

  isValidVisitorData(visitor: unknown): boolean {
    return OptimizelyVisitor.STATUSES.includes(visitor?.status)
  }

  createVisitor(): OptimizelyVisitorData {
    return {
      status: 'new',
    }
  }

  getVisitorData(): OptimizelyVisitorData {
    const visitor = this.storage.get(OptimizelyVisitor.STORAGE_KEY)

    return this.isValidVisitorData(visitor) ? visitor : null
  }

  setVisitorData(data: OptimizelyVisitorData) {
    this.storage.set(OptimizelyVisitor.STORAGE_KEY, data)
  }

  setVisitorNew() {
    this.setVisitorData(this.createVisitor())
  }

  setVisitorReturning() {
    const visitorData = this.getVisitorData() || this.createVisitor()

    if (visitorData.status === 'new') {
      this.setVisitorData({
        ...visitorData,
        status: 'returning',
      })
    }
  }

  handleVisitor() {
    if (this.isReturningVisitor()) {
      this.setVisitorReturning()
    } else {
      this.setVisitorNew()
    }
  }
}

export const optimizelyVisitor = new OptimizelyVisitor(
  new Storage('localStorage')
)
export const handleOptimizelyVisitor = () => optimizelyVisitor.handleVisitor()
